<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <el-button v-if="backRole('CM_2')" type="primary" @click="startCreate()" size="mini">前往添加会议</el-button>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
    </div>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="listType">
        <el-radio-button label="0">进行中</el-radio-button>
        <el-radio-button label="1">已审批通过</el-radio-button>
        <el-radio-button label="2">已取消/拒绝</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>

      <el-table-column label="会议名称">
        <template slot-scope="scope">
          <!-- <a href="javascript:;" class="link"></a> -->
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="会议地点" width="100px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.room.deptName+' - '+scope.row.room.address"
            placement="bottom">
            <span>
              <i class="iconfont icon-address"></i>
              <span v-html="scope.row.room.address"></span>
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="conferenceTime" label="会议时间" width="160px"></el-table-column>
      <!-- <el-table-column label="参会人员" width="160px">
        <template slot-scope="scope">
          <div v-html="getUserList(scope.row.users)"></div>
          <a href="javascript:;" @click="showMeetingInfo(scope.row.id)" v-if="scope.row.users.length>3" class="user-item">...</a>
        </template>
      </el-table-column> -->

      <el-table-column label="审批发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData="scope.row.flow.creator"></user-info>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)">详情</el-button>

          <!-- <el-tooltip class="item" effect="dark" content="编辑款项类别" placement="bottom">
            <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="editPayTypeBtnClick(scope.row)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除款项类别" placement="bottom">
            <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="deletePayType(scope.row)"></i>
          </el-tooltip>-->

          <!-- 填表人修改权限 -->
          <span v-if="scope.row.flow.creator.id==userData.id">
            <span v-if="scope.row.flow.status!='审批通过'">
              <el-tooltip class="item" effect="dark" content="修改会议申请审批" placement="bottom">
                <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit"
                  @click="getRouterLink(scope.row)"></i>
              </el-tooltip>
            </span>
            <cancel-flow :flow="scope.row.flow" @getLists="getLists"></cancel-flow>
          </span>

        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>


    <!-- 会议资料详情 -->
    <meeting-info v-if="meetingInfoStatus" :meetingId="meetingId" :meetingInfoStatus="meetingInfoStatus" v-on:hideMeetingInfo="hideMeetingInfo()"></meeting-info>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import CancelFlow from "@/components/CancelFlow";
  import UserInfo from "@/components/UserInfo";
  import ApprovalStatus from "@/components/ApprovalStatus";
  import projectInfo from '@/page/user/projectInfo'
  import Role from "@/Mixins/role";

  import MeetingInfo from '@/components/MeetingInfo'
  export default {
    components: {
      UserInfo,
      MeetingInfo,
      ApprovalStatus,
      CancelFlow,
      projectInfo
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,
        depId: "",

        listType: 0,
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        
        // 会议资料详情
        meetingInfoStatus: false,
        meetingId: "",

        // 取消审批相关
        cancleStatus: false,
        form: {
          flowId: "",
          remark: ""
        }
      };
    },
    created() {},
    mounted() {
      // this.organizationListData.push({
      //   id: 0,
      //   name: "集团所有公司",
      //   depId: 0
      // });
      let _or =
        this.organization.length > 0 ? this.organization[0].childDepts : [];
      this.organizationListData = this.organizationListData.concat(_or);

      this.depId = this.userData.secDepIds.split(",")[0] / 1;

      if (this.depId == "7" || this.backRole("SYSTEM_1")) {
        this.noSelectOrganization = false;
        // this.depId = 0;
      }
    },
    methods: {

      getUserList(users) {
        let _item = ""
        for (var i = 0; i < users.length; i++) {
          _item += '<span class="user-item">' + users[i].name + '</span>'
        }
        return _item
      },

      startCreate() {
        this.$router.push("/Meeting/Room/List")
      },

      // 编辑的链接生成
      getRouterLink(row) {
        this.$router.push({
          path: "/Meeting/CreateApproval",
          query: {
            depId: row.department.id,
            roomId: row.room.id,
            applyId: row.id
          }
        });
      },

      // 取消审批提交
      cancelFlowSubmit() {
        ajax.post("/gc/project/flow/cancel", this.form, res => {
          this.$message.success("取消审批成功");
          this.$store.commit("set_projectReload", true);
          this.cancleStatus = false;
          this.getLists();
        });
      },
      // 取消审批弹窗
      cancelFlow(flow) {
        this.form.flowId = flow.id;
        this.cancleStatus = true;
      },

      // 显示审批详情
      projectDetail(row) {
        console.log(row)
        let _projectTable = {
          status: true,
          applyId: row.flow.applyId,
          tableType: row.flow.flowsource,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        if (this.filterType != 0 || this.filterKey) {

        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        ajax.get('/conference/apply/list', {
          'depId': this.depId != 0 ? this.depId : "",
          'type': this.listType
        }, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getFilterData()
        })
      },
    },
    watch: {
      'depId'() {
        this.currentPage = 1
        this.getLists()
      },
      'filterKey'() {
        this.getFilterData()
      },

      listType() {
        this.currentPage = 1
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/meeting/approvalList.vue